<template>
  <div>
  
    <component :data-obj="dataObj" :is="dataObj.componentName" />
  </div>
</template>

<script>
import ApplicationService from "@/services/application";
 import * as components from "@/components";

  const app = new ApplicationService();

  export default {
    name: "tab-component",
    props: {
      dataObj: {
        type: Object,
        required: true,
      },
    },
    methods: {
      
      openNewTab() {
        let routeData = this.$router.resolve({name: "clients-equipment-list"});
        window.open(routeData.href, "_blank");
      },
    },
    components: {
      ...components,
    },
  };
</script>
